<!-- 项目文件 -->
<template>
    <div class="w100p bgfff">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt24  pb24 bg79">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    主流媒体推荐
                </span>
            </p>
            <div class="pt30  w100p">
                <van-image lazy-load class="imgauto" :src="img68" />
            </div>

        </div>

        <div class="pt24 pl16 pr16 pb32">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    校园推广渠道
                </span>
            </p>
            <div class="pt40 w100p">
                <ul class="w100p disblock row1_txtc alit">
                    <li class="disinblock">
                        <img class="w78 h78" src="../../../public/img/img69.png" alt="">
                    </li>

                    <li class="disinblock">
                        <img class="w30 h30" src="../../../public/img/img72.png" alt="">
                    </li>

                    <li class="disinblock">
                        <img class="w78 h78" src="../../../public/img/img70.png" alt="">
                    </li>

                    <li class="disinblock">
                        <img class="w30 h30" src="../../../public/img/img72.png" alt="">
                    </li>

                    <li class="disinblock">
                        <img class="w78 h78" src="../../../public/img/img71.png" alt="">
                    </li>
                </ul>
            </div>
        </div>

        <div class="pt24 pl16 pr16 pb32 bg73">
            <p class="fs16 cfff disinblock posre textc w100p flexc">
                <span class="border-bottomfff cfff">
                    APP推广
                </span>
            </p>
            <div class="pt30  w100p">
                <van-image lazy-load class="imgauto" :src="img74" />
            </div>
        </div>

        <div class="pt24 pl16 pr16 pb70 bgf6">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1 ">
                    更多推广方式
                </span>
            </p>
            <div class="pt25  w100p">
                <van-row gutter="20">
                    <van-col span="12">
                        <p class="bg1f8 textc cfff fs14 pt10 pb10 pl15 pr15">
                            电台主持人分享
                        </p>
                        <div class="bgfff pb16 textc">
                            <div class=" pt16">
                                <img class="w52 h52" src="../../../public/img/img75.png" alt="">
                                <P class="c333 fs14 pt8">
                                    微信分享推荐
                                </P>
                            </div>

                            <div class=" pt16">
                                <img class="w52 h52" src="../../../public/img/img77.png" alt="">
                                <P class="c333 fs14 pt8">
                                    电台主播推荐
                                </P>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <p class="bg1f8 textc cfff fs14 pt10 pb10 pl15 pr15">
                            小程序推荐
                        </p>
                        <div class="bgfff pb16 textc">
                            <div class=" pt16">
                                <img class="w52 h52" src="../../../public/img/img76.png" alt="">
                                <P class="c333 fs14 pt8">
                                    微信分享推荐
                                </P>
                            </div>
                        
                            <div class=" pt16">
                                <img class="w52 h52" src="../../../public/img/img78.png" alt="">
                                <P class="c333 fs14 pt8">
                                    电台主播推荐
                                </P>
                            </div>
                        </div>
                    </van-col>
                   
                </van-row>
              
            </div>

        </div>
      
        <Applyset></Applyset>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import Applyset from '@/components/Applyset';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img80.png'),
                img68: require('../../../public/img/img68.png'),
                img74: require('../../../public/img/img74.png'),
                isAct: 1,
            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            Applyset
        },
        methods: {},
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg79 {
        background-image: url('../../../public/img/img79.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    
    .bg73 {
        background-image: url('../../../public/img/img73.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
</style>